import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    const consent = {
      necessary: true,
      analytics: true,
      marketing: true,
      functional: true,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
    setShowBanner(false);
  };

  const handleDecline = () => {
    const consent = {
      necessary: true,
      analytics: false,
      marketing: false,
      functional: false,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 20, opacity: 0 }}
        transition={{ duration: 0.2 }}
        className="fixed bottom-4 right-4 z-50 bg-white/70 backdrop-blur-xl border border-white/40 shadow-[0_8px_32px_rgba(0,0,0,0.12)] rounded-2xl px-5 py-3.5 flex items-center gap-4"
      >
        <p className="text-xs text-gray-700">
          WE USE COOKIES.{' '}
          <Link to="/privacy" className="underline hover:text-gray-900 transition-colors">
            LEARN MORE
          </Link>
        </p>

        <div className="flex items-center gap-2">
          <button
            onClick={handleDecline}
            className="text-[10px] font-medium uppercase tracking-wider text-gray-500 hover:text-gray-800 transition-colors px-2 py-1"
          >
            DECLINE
          </button>
          <button
            onClick={handleAccept}
            className="text-[10px] font-medium uppercase tracking-wider bg-[#001A57] text-white px-3 py-1.5 hover:bg-[#003087] transition-colors"
          >
            ACCEPT
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default CookieConsent;
